import { DefaultOptions } from "@tanstack/react-query";

import { ClosingTimePolicyOwner } from "src/api/product/product-types";
import useGetReservationPolicy from "./useGetReservationPolicy";

/**
 * 휴무일(closing-time-policy) 정책 조회 - RRVP03/09
 *
 * 상품/계약 하나의 휴무 정책을 전부(기본 정책 + 공간별 개별 정책) 받아온다.
 * 선별은 utils/closingTime 의 find* 헬퍼 사용.
 *
 * @returns ClosingTimePolicyModel[]
 */
const useGetClosingTimePolicy = ({ owner, defaultOptions }: { owner: ClosingTimePolicyOwner; defaultOptions?: DefaultOptions["queries"] }) =>
  useGetReservationPolicy({ owner, policyType: "closing-time-policy", defaultOptions });

export default useGetClosingTimePolicy;
